<template>
	<div>
		<li>
			<div :class="{bold: isFolder,list:true}">
				<span @click="toggle" class="listItem menu">
					<span v-if="isFolder"><i :class="open ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i>{{model.name}}</span> 
					<span v-else class="notFolder">{{model.name}}</span> 
				</span>
				<span class="listItem path">
					<label v-if="!model.genre || model.genre == null">-</label>
					<label v-if='model.genre==1'>菜单</label>
					<label v-if='model.genre==2'>按钮</label>
					<label v-if='model.genre==3'>权限</label>
				</span>
				<span class="listItem componentPath">
					<label v-if="!model.href || model.href == null">-</label>
					<label v-else>{{model.href}}</label>
				</span>
				<span class="listItem isShow">
					<label v-if="model.isShow == 1">显示</label>
					<label v-if="model.isShow != 1">隐藏</label>
				</span>
				<span class="listItem sign">
					<label v-if="!model.permission || model.permission == null">-</label>
					<label v-else>{{model.permission}}</label>
				</span>
				<span class="listItem option" id='listItem_super'>
					<span v-if='true'>
						<el-button type='warning' size="mini" @click="handleCommand('modify')" class='elButton'>编辑</el-button>
						<el-button class='minButton elButton' size="mini" @click="handleCommand('add')">新增下级</el-button>
						<el-button type="danger" size="mini" @click="handleCommand('remove')" class='elButton'>删除</el-button>
						<el-button type="danger" size="mini" @click="handleCommand('synchro')" class='elButton'>同步到角色</el-button>
					</span>
					<!-- <span  v-else>
						<el-button type="text" size="mini" @click="handleCommand('modify')" class='elButton'>编辑</el-button>
						<el-button type="text" size="mini" @click="handleCommand('add')" class='elButton'>新增下级</el-button>
						<el-button type="text" size="mini" @click="handleCommand('remove')" class='elButton'>删除</el-button>
						<el-button type="danger" size="mini" @click="handleCommand('synchro')" class='elButton'>同步到角色</el-button>
						
					</span> -->
					
				</span>
			</div>
			<ul v-show="open" v-if="isFolder" class="itemStyle">
				<item class="item" v-for="model in model.children" :model="model" v-on:add="listenAdd" :key="model.id">
				</item>
			</ul>
		</li>
		
	</div>
</template>

<script>
	
	export default {
		name: 'item',
		props: {
			model: Object,
			default: {}
		},
		data() {
			return {
				open: true,
				superControl: false,
			}
		},
		created() {
			let _ = this; 
			 window.onresize = function () {  //监听屏幕的改变
			 	_.superControl = true;
			     console.log(_.superControl)
			};
		},
		computed: {
			isFolder() {
				return this.model.children &&
					this.model.children.length
			}
		},
		methods: {
			toggle() {
				if(this.isFolder) {
					this.open = !this.open
				}
			},
			handleCommand(command) {
				let _this = this;
				if(command == "add") {
					let data = {
						type:command,
						title:'新增菜单'	,
						id:'',
						name:'',	
						parent:this.model.name,
						parentId:this.model.id,
						componentPath: '',
						sign:'',
						genre:'1',
						sort:'',
						isShow:1,
						icon: '',
					};
					this.$emit('add',data);
				} else if(command == "modify") {
					let data = {
						type:command,
						title:'编辑菜单',
						id:this.model.id,
						name:this.model.name,
						componentPath: this.model.href,
						parent:'',
						sign:this.model.permission,
						parentId:this.model.fkParantId,
						isShow:this.model.isShow,
						sort:this.model.sort,
						genre:this.model.genre,
						functions:this.model.function,
						icon: this.model.icon
					};
					this.$emit('add',data);
				} else if(command == "remove") {
					let data = {
						type:command,
						id:this.model.id,
					}
					this.$emit('add',data);
				}else if(command == "synchro"){
					let data = {
						title:'同步菜单到角色',
						type:command,
						id:this.model.id
						
					}
					this.$emit('add',data);
				}
			},
			listenAdd(data){
				this.$emit('add',data);
			}
		},
	}
</script>

<style lang="less">
#pagesite {
	ul, ol {
		list-style: none;
	}
	.bold {
		font-weight: bold;
	}
	.list {
		font-size: 0px;
		height: 50px;
		line-height: 50px;
		border: 1px solid #ddd;
		border-bottom: none;
		.listItem {
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			font-size:14px ;
			display: inline-block;
			border-right: 1px solid #ddd;
			// width: 16.6666666667%;
			padding: 0 10px;
			text-align: center;
			cursor: pointer;
			box-sizing: border-box;
			&.menu {
				cursor: pointer;
				text-align: left;
				width: 16.6666666667%; 
			}
			&.path{
 				width: 5%; 
			}
			&.componentPath{
 				width: 16%; 
			}
			&.isShow{
 				width: 5%; 
			}
			&.sign{
 				width: 16%; 
			}

			&.option {
 				width: 41.333344% ;	
			}
		}

		&:hover{
			background-color: #eee;
		}
	}
	.itemStyle .item .menu{
		padding-left: 40px;
	}
	.itemStyle .item .menu .notFolder{
		font-weight: normal;
	}
	
}
</style>


// WEBPACK FOOTER //
// src/components/Set/pageitem.vue